import { DispatchReset, PagedReducer, PagedReducerReset } from "base/src/utils/reducerUtil";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { DELETARPEDIDO, LOTEPEDIDO_APROVAR, LOTEPEDIDO_CREATE, LOTEPEDIDO_GET, LOTEPEDIDO_GET_BYID, PAGARPEDIDO, LotePedidoActionTypes, LotePedidoState } from "../../../types/lotePedido/lotePedido";
import { LotePedidoResponse } from "../../../types/lotePedido/lotePedidoResponse";
import ValidationResult from "domain/types/global/validationResult";

const INITIAL_STATE: LotePedidoState = {
	LotePedido: undefined,
	LotePedidoById: undefined,
	PagarPedido: undefined,
	mudancaStatus: {} as ValidationResult,
};

export function PedidoLotesReducer(
	state = INITIAL_STATE,
	action: LotePedidoActionTypes
): LotePedidoState {
	switch (action.type) {
		case LOTEPEDIDO_GET:
			return PagedReducer(state, "LotePedido", action.payload, "CampanhaPedidoResgatePagamentoID", LOTEPEDIDO_GET)
		case DispatchReset(LOTEPEDIDO_GET):
			return PagedReducerReset(state, "LotePedido", {} as IPagedListResponse<LotePedidoResponse>, "CampanhaPedidoResgatePagamentoID", LOTEPEDIDO_GET)
		case LOTEPEDIDO_APROVAR:
			return { ...state, mudancaStatus: action.payload };
		case LOTEPEDIDO_CREATE:
			return { ...state, mudancaStatus: action.payload };
		case LOTEPEDIDO_GET_BYID:
			return { ...state, LotePedidoById: action.payload }
		case DELETARPEDIDO:
			return { ...state, mudancaStatus: action.payload }
		case PAGARPEDIDO:
			return { ...state, mudancaStatus: action.payload }
		default:
			return state;
	}
}
